import { render } from "./Antivirus.vue?vue&type=template&id=1cd4126b&scoped=true"
import script from "./Antivirus.vue?vue&type=script&lang=js"
export * from "./Antivirus.vue?vue&type=script&lang=js"

import "./Antivirus.vue?vue&type=style&index=0&id=1cd4126b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1cd4126b"

export default script